<template>
  <div class="tabs_content" v-show="$_loggedUser_action_allowed('subscribers')">
    <section>
      <div class="status"><h2 v-translate>Odběratelské profily</h2>
        <a
            v-if="isEditable"
            @click.stop.prevent="_createNewProfile"
            :title="$gettext('Odběratelské profily')"
            class="add add_expand"
            v-translate>Přidat profil odběratele</a>
      </div>

      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="subscribers-profiles">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <ProfileRow v-for="profile in entities"
                        :profile="profile"
                        :id-subscriber="entity.id"
                        :key="profile.id"
                        ref="profile_row"
                        :selectedEntities="selectedEntities"
                        :isDeletable="isEditable && !lastProfile"
                        @input="select"
                        @deleteProfile="deleteProfile" />
            <tr v-if="entities.length === 0">
              <td colspan="5" v-translate>Nebyly nalezeny žádné profily.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-profiles"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import ProfileRow from "./ProfileRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailProfiles",
  components: { ProfileRow },
  mixins: [listActions],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      totalCount: 0,
      formFields: {
        limit: 50,
        offset: 0,
        search: '',
        sort: {
          column: 'sLastUsedDate',
          direction: 'desc'
        }
      },
    }
  },
  created(SubscriberService, SubscriberProfileService) {
    this.subscriberService = SubscriberService
    this.subscriberProfileService = SubscriberProfileService

    this.getEntities()
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getProfiles(this.entity.id, params).then((data) => {
        this.entities = data['profiles']
        this.totalCount = data['totalCount']
      })
    },
    deleteProfile(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteProfile');
      } else {
        this.subscriberProfileService.deleteEntity(id, { id_selected_operator: this.$_loggedUser_selectedOperatorId })
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },

    _createNewProfile() {
      this.$router.push({
        name: 'subscriberProfileNew',
        params: {
          idSubscriber: this.entity.id
        }
      });
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteProfile(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getProfiles(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['profiles']);
      })
    },
  },
  computed: {
    lastProfile() {
      return this.entities.length <= 1;
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sName' },
        { id: 2, name: this.$gettext('Profilový obrázek') },
        { id: 3, name: this.$gettext('Dětský profil') },
        { id: 4, name: this.$gettext('Věkový limit') },
        { id: 5, name: this.$gettext('Přístup s PINem') },
        { id: 6, name: this.$gettext('Editace s PINem') },
        { id: 7, name: this.$gettext('Naposledy použito'), column: 'sLastUsedDate' },
        { id: 8, name: this.$gettext('Poslední zařízení') },
        { id: 9, name: this.$gettext('Vytvořeno') },
      ]
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'is_child': {
          name: this.$gettext('Dětský profil'), callback: (entity) => {
            return entity.is_child ? 'ANO' : 'NE'
          }
        },
        'age_limit': { name: this.$gettext('Věkový limit') },
        'access_with_pin': {
          name: this.$gettext('Přístup s PINem'), callback: (entity) => {
            return entity.security.access_with_pin ? 'ANO' : 'NE'
          }
        },
        'edit_with_pin': {
          name: this.$gettext('Editace s PINem'), callback: (entity) => {
            return entity.security.edit_with_pin ? 'ANO' : 'NE'
          }
        },
        'timestamp_created': {
          name: this.$gettext('Vytvořeno'), callback: (entity) => {
            return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''
          }
        },
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/profiles/Profiles.vue